import { createUseStyles } from 'react-jss'
import { colors } from '../colors'

const useLoaderStyles = createUseStyles({
  '@keyframes flash': {
    '0%': {
      backgroundColor: colors.gray100
    },
    '50%, 100%': {
      backgroundColor: colors.gray200
    }
  },
  '@keyframes barScale': {
    '0%': {
      transform: 'scale(1)'
    },
    '20%': {
      transform: 'scale(1, 2.2)'
    },
    '40%': {
      transform: 'scale(1)'
    }
  },
  absolute: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)'
  },
  barLoaderItem: {
    display: 'inline-block',
    width: '4px',
    height: '18px',
    borderRadius: '4px',
    marginLeft: '2px',
    animation: '$barScale 1s ease-in-out infinite',

    '&:nth-child(1)': {
      backgroundColor: '#3498db',
      animationDelay: 0
    },
    '&:nth-child(2)': {
      backgroundColor: '#c0392b',
      animationDelay: '0.09s'
    },
    '&:nth-child(3)': {
      backgroundColor: '#f1c40f',
      animationDelay: '0.18s'
    },
    '&:nth-child(4)': {
      backgroundColor: '#27ae60',
      animationDelay: '0.27s'
    }
  },
  dotsLoader: {
    position: 'relative',
    width: '8px',
    height: '8px',
    borderRadius: '100%',
    backgroundColor: colors.gray100,
    color: colors.gray100,
    animation: '$flash 0.5s infinite linear alternate',
    animationDelay: '0.25s',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '-12px',
      width: '8px',
      height: '8px',
      borderRadius: '100%',
      backgroundColor: colors.gray100,
      color: colors.gray100,
      animation: '$flash 0.5s infinite alternate',
      animationDelay: '0s'
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      left: '12px',
      width: '8px',
      height: '8px',
      borderRadius: '100%',
      backgroundColor: colors.gray100,
      color: colors.gray100,
      animation: '$flash 0.5s infinite alternate',
      animationDelay: '0.5s'
    }
  }
})

export { useLoaderStyles }
